const Dashboard = () => {
  return (
    <>
      {/* TODO FOR FUTURE DASHBOARD */}
    </>
  )
}

export default Dashboard;